export default __webpack_public_path__ + "assets/tornado.1eea9a31.svg";